import './ShareProfileModal.css'

const ModalTalentRow = ({ name, title, avatar, aiScore, tag = 'External', online = true }) => (
  <div className="spm-talent-row">
    <div className="spm-avatar">
      {avatar && <img src={avatar} alt={name} />}
      {online && <span className="spm-online-dot" />}
    </div>
    <div className="spm-talent-info">
      <span className="spm-talent-name">{name}</span>
      <span className="spm-talent-title">{title}</span>
    </div>
    <div className="spm-talent-meta">
      {aiScore && <span className="spm-ai-score">✦ AI Score {aiScore}</span>}
      <span className="spm-tag-external">{tag}</span>
    </div>
  </div>
)

export default ModalTalentRow
